import { ref } from 'vue'
import { useEventListener } from 'src/composables/useEventListener'

// Forter dispatches ftr:tokenReady once its fraud-detection fingerprint is ready. The
// script itself loads site-wide (see useForterScript, called from App.vue/OtaApp.vue),
// but the token is only needed — and so only listened for — on the payment page.
export function useForterToken() {
  const forterToken = ref(null)

  useEventListener(document, 'ftr:tokenReady', (evt) => {
    forterToken.value = evt.detail
  })

  return { forterToken }
}
